<template>
  <div class="d-flex flex-column fill-height">
    <v-toolbar style="height: 56px !important; max-height: 56px !important; min-height: 56px !important" flat dense dark color="grey darken-4">
      <v-btn icon @click="selectGroup(null)" v-if="$vuetify.breakpoint.smAndDown">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

  

      <template v-if="!isSearchActive">
        <v-toolbar-title v-if="activeGroupData" class="font-weight-bold text-truncate pl-1">
          <img height="32px" width="32px" style="border-radius: 50%" v-if="activeGroupData.bild" :src="'/img/profilbilder/' + activeGroupData.bild"></img>
          {{ activeGroupData.name }}
        </v-toolbar-title>
      </template>

      <v-spacer></v-spacer>

   <v-btn icon @click="toggleSearch(true)">
  <v-icon>mdi-magnify</v-icon>
</v-btn>

      <v-btn icon @click="showSettingsDialog = true"> 
        <v-icon>mdi-cog</v-icon>
      </v-btn>
    </v-toolbar>

    <ChatGroupSettingsDialog v-if="activeGroupData" v-model="showSettingsDialog" :group="activeGroupData" />
    <ForwardMessageDialog 
      v-if="showForwardDialog" 
      v-model="showForwardDialog" 
      :message="selectedMessageToForward" 
    />
    <ReadReceiptsDialog
      v-if="selectedMessageForReceipts"
      v-model="showReadReceipts"
      :read-by="selectedMessageForReceipts.readBy"
      :members="activeGroupData.members"
      @input="
        ($event) => {
          $event ? '' : (selectedMessageForReceipts = null)
        }
      " />
    <MediaViewerDialog v-if="selectedMediaItem" v-model="showMediaViewer" :item="selectedMediaItem" :key="selectedMediaItem._id" />

    <v-progress-linear indeterminate v-if="isLoadingMessages" color="primary"></v-progress-linear>
    <div class="chat-messages-container flex-grow-1 pa-4" ref="messagesContainer">
      <div 
          ref="loadMoreTrigger"
          v-if="hasMoreMessages" 
          class="pa-4 text-center"
          style="min-height: 56px;" >
          <v-progress-circular
            v-if="isLoadingMoreMessages"
            indeterminate
            color="primary"
            size="32"
          ></v-progress-circular>
        </div>
      <v-container v-if="!isLoadingMessages && filteredMessages.length === 0 && !searchQuery" class="fill-height" fluid>
        <v-row align="center" justify="center" class="fill-height">
          <v-col cols="12" class="text-center grey--text text--darken-1">
            <v-icon size="80" color="grey darken-2">mdi-message-arrow-left-outline</v-icon>
            <p class="mt-4 headline">Es ist noch nichts hier</p>
            <p class="body-1">Sende die erste Nachricht!</p>
          </v-col>
        </v-row>
      </v-container>

      <v-container v-if="searchQuery && filteredMessages.length === 0" class="fill-height" fluid>
        <v-row align="center" justify="center" class="fill-height pa-4">
          <v-col cols="12" class="text-center grey--text text--lighten-1">
            <v-icon size="60" color="grey darken-2">mdi-magnify-close</v-icon>
            <p class="mt-4 headline">Keine Treffer</p>
            <p class="body-1">Für "{{ searchQuery }}" wurden keine Nachrichten gefunden.</p>
          </v-col>
        </v-row>
      </v-container>
<div class="floating-fabs-container">
        
        <v-slide-y-reverse-transition>
          <v-btn
            v-if="showNewMessagesBanner"
            rounded
            depressed
            color="primary"
            class="mb-2 new-msgs-btn"
            @click="onNewMessagesBannerClick">
            <v-icon left>mdi-arrow-down</v-icon>
            Neue Nachrichten
          </v-btn>
        </v-slide-y-reverse-transition>

      <v-scale-transition origin="center center">
          <v-btn
            v-if="isHistoryMode"
            :loading="isReturningToPresent" 
            fab
            dark
            color="grey darken-3"
            class="history-fab elevation-6"
            @click="handleReturnToPresent"
          >
            <v-icon color="white">mdi-chevron-double-down</v-icon>
          </v-btn>
        </v-scale-transition>
      </div>
      <div v-if="filteredMessages.length > 0">
        <v-scroll-y-transition group>
          <div v-for="(item, key) in messagesWithDateSeparators" :key="item.isSeparator ? item.date : item._id">
            <div v-if="item.isSeparator" class="date-separator">
              <span>{{ item.date }}</span>
            </div>

            <div v-else :id="'msg-' + item._id" class="d-flex mb-3" :class="isMyMessage(item) ? 'justify-end' : 'justify-start'">
              <v-avatar @click="viewUserProfile(item.senderId)" v-if="!isMyMessage(item)" class="mr-2 my-auto" size="36">
                <v-img v-if="item.senderId && item.senderId.bild" :src="'/img/profilbilder/' + item.senderId.bild" alt="Profilbild"></v-img>
                <v-sheet v-else color="grey darken-2" class="fill-height d-flex justify-center align-center">
                  <span class="white--text text-caption">
                    {{ getInitials(item.senderId) }}
                  </span>
                </v-sheet>
              </v-avatar>

              <v-sheet v-if="item.messageType === 'system'" rounded="xl" class="pa-2 mx-auto my-2 system-message" max-width="80%">
                <em class="caption">{{ item.textContent }}</em>
              </v-sheet>
              <v-sheet v-else-if="item.isDeleted" rounded="xl" class="pa-3 message-bubble grey">
                <v-icon small class="mr-1" color="red">mdi-delete-empty</v-icon>
                <em>Diese Nachricht wurde gelöscht.</em>
              </v-sheet>

              <template v-else>
                <div class="bubble-container d-flex flex-column" :class="isMyMessage(item) ? 'align-end' : 'align-start'">
                  <v-menu
                    offset-y
                    content-class="glass-menu"
                    :close-on-content-click="true"
                    v-model="activeMenuId === item._id"
                    @input="(val) => !val && onMenuClose()">
                    <template v-slot:activator="{ attrs }">
                      <v-sheet
                        v-bind="attrs"
                        class="message-bubble"
                        :class="{
                          'is-me': isMyMessage(item),
                          'is-other': !isMyMessage(item),
                          'is-my-mention': isMyMention(item),
                          'bubble-pressing': activePressId === item._id,
                          'bubble-lifted': activeMenuId === item._id,
                        }"
                        style="cursor: pointer"
                        :style="item.messageType === 'audio' ? 'max-width: unset !important' : ''"
                        :data-message-id="item._id"
                        @mousedown.prevent="onPressStart(item, $event)"
                        @touchstart="onPressStart(item, $event)"
                        @mouseup="onPressEnd(item)"
                        @touchend="onPressEnd(item)"
                        @mouseleave="onPressEnd(item)"
                        @contextmenu.prevent="onLongPress(item, $event.currentTarget)"
                        @mousemove="onMove($event)"
                        @touchmove.passive="onMove($event)">
                        <div v-if="item.isForwarded" class="caption grey--text text--lighten-1 mb-1" style="font-style: italic">
                          <v-icon small>mdi-share</v-icon> Weitergeleitet
                        </div>
                        <div v-if="item.isBroadcast" class="caption primary--text text--lighten-2 mb-1" style="font-style: italic">
                          <v-icon small color="primary">mdi-bullhorn-outline</v-icon>
                          Rundsendung
                        </div>
                        <v-sheet
                          v-if="item.replyToMessageId"
                          class="reply-bubble mb-2"
                          rounded="lg"
                          @click.stop="scrollToMessage(item.replyToMessageId._id)">
                          <template v-if="item.replyToMessageId.isDeleted">
                            <div class="pa-2 grey--text" style="font-style: italic">
                              <v-icon small color="red">mdi-delete-empty</v-icon>
                              Gelöschte Nachricht
                            </div>
                          </template>
                          <template v-else>
                            <div class="reply-bubble-sender font-weight-bold">
                              {{ item.replyToMessageId.senderId ? item.replyToMessageId.senderId.vorname : "..." }}
                            </div>
                            <div class="reply-bubble-content">
                              {{ item.replyToMessageId.textContent }}
                            </div>
                          </template>
                        </v-sheet>
                        <div v-if="!isMyMessage(item)" class="sender-name font-weight-bold mb-1">
                          {{ item.senderId ? item.senderId.vorname : "..." }}
                        </div>
                        <div v-if="item.messageType === 'image' && scrollContainerElement" class="mb-1 secured-media-preview">
                          <SecuredMedia :scroll-container="scrollContainerElement" :noObserver="key > messagesWithDateSeparators.length - 9"  :filename="item.fileUrl" mediaType="image" style="max-width: 300px; max-height: 400px; border-radius: 8px" />
                        </div>
                        <div v-else-if="item.messageType === 'video' && scrollContainerElement" class="mb-1 secured-media-preview">
                          <SecuredMedia :scroll-container="scrollContainerElement" :noObserver="key > messagesWithDateSeparators.length - 9"  :filename="item.fileUrl" mediaType="video" style="max-width: 300px; max-height: 400px; border-radius: 8px" />
                        </div>
                      <div v-else-if="item.messageType === 'audio' && scrollContainerElement" class="mb-1 secured-media-preview">
                        <SecuredMedia :scroll-container="scrollContainerElement" :filename="item.fileUrl" :noObserver="key > messagesWithDateSeparators.length - 9"   mediaType="audio" />
</div>
   <div v-else-if="item.messageType === 'file'" class="mb-1">
  <v-tooltip bottom color="black" :disabled="$vuetify.breakpoint.mobile">
    <template v-slot:activator="{ on, attrs }">
      <v-sheet
        @click.stop="downloadSecuredFile(item)"
        rounded="lg"
        class="pa-3 d-flex flex-column align-center justify-center"
        color="rgba(0,0,0,0.2)"
        style="cursor: pointer; width: 140px; height: 140px; position: relative; overflow: hidden"
        v-bind="attrs"
        v-on="on"
      >
        <v-progress-circular
          v-if="downloadingFileId === item._id"
          indeterminate
          color="white"
          size="48"
        ></v-progress-circular>

        <template v-else>
           <v-icon size="48" color="white" class="mb-2">
             {{ getFileIcon(item.fileInfo) }}
           </v-icon>
           
           <span
            class="text-caption d-block text-truncate"
            style="color: rgba(255,255,255,0.9); max-width: 100%;"
           >
            {{ item.fileInfo.originalName || "Datei" }}
           </span>
           
           <v-icon small color="rgba(255,255,255,0.5)" class="mt-1">mdi-download</v-icon>
        </template>
        
      </v-sheet>
    </template>
    <span>{{ item.fileInfo.originalName || "Datei herunterladen" }}</span>
  </v-tooltip>
</div>
                        <div v-if="item.textContent" class="message-content" v-text="item.textContent"></div>
                        <div class="message-time text-caption">
                          {{ formatTimestamp(item.createdAt) }}
                          <v-icon v-if="isMyMessage(item)" :color="getReadStatus(item).color" small class="ml-1" style="vertical-align: middle">
                            {{ getReadStatus(item).icon }}
                          </v-icon>
                        </div>
                        <div v-if="item.isEdited" class="message-time text-caption mt-1 text-right" style="opacity: 0.7; font-style: italic">
                          Bearbeitet
                        </div>
                      </v-sheet>
                    </template>

                    <v-list dense dark>
                      <v-list-item>
                        <v-list-item-action class="d-flex flex-row justify-space-around">
                          <v-btn v-for="emoji in quickReactions" :key="emoji" icon @click="onReactionClick(item, emoji)">
                            <span style="font-size: 1.5rem">{{ emoji }}</span>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item @click="setReplyTo(item)">
                        <v-list-item-icon><v-icon>mdi-reply</v-icon></v-list-item-icon>
                        <v-list-item-title>Antworten</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="openForwardDialog(item)">
                        <v-list-item-icon><v-icon>mdi-share</v-icon></v-list-item-icon>
                        <v-list-item-title>Weiterleiten</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="isMyMessage(item)" @click="editMessage(item)">
                        <v-list-item-icon><v-icon>mdi-pencil</v-icon></v-list-item-icon>
                        <v-list-item-title>Bearbeiten</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="isMyMessage(item)" @click="deleteMessage(item)">
                        <v-list-item-icon><v-icon color="red">mdi-delete</v-icon></v-list-item-icon>
                        <v-list-item-title class="red--text text--lighten-2">Löschen</v-list-item-title>
                      </v-list-item>
                      <v-divider v-if="isMyMessage(item)"></v-divider>
                      <v-list-item v-if="isMyMessage(item)" @click="openReadReceipts(item)">
                        <v-list-item-icon><v-icon>mdi-information-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>Gelesen von...</v-list-item-title>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item v-if="!isPersonallyPinned(item._id)" @click="savePersonalPin(item)">
      <v-list-item-icon><v-icon>mdi-bookmark-outline</v-icon></v-list-item-icon>
      <v-list-item-title>Merken</v-list-item-title>
    </v-list-item>
    <v-list-item v-if="isPersonallyPinned(item._id)" @click="removePersonalPin(item)">
      <v-list-item-icon><v-icon color="primary">mdi-bookmark</v-icon></v-list-item-icon>
      <v-list-item-title>Gemerkt</v-list-item-title>
    </v-list-item>

    <template v-if="hasPinRight">
      <v-list-item v-if="!isGloballyPinned(item._id)" @click="saveGlobalPin(item)">
        <v-list-item-icon><v-icon>mdi-pin-outline</v-icon></v-list-item-icon>
        <v-list-item-title>Global anpinnen</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="isGloballyPinned(item._id)" @click="removeGlobalPin(item)">
        <v-list-item-icon><v-icon color="primary">mdi-pin</v-icon></v-list-item-icon>
        <v-list-item-title>Globaler Pin</v-list-item-title>
      </v-list-item>
    </template>
                    </v-list>
                  </v-menu>

                  <div class="reaction-chips-container" :class="isMyMessage(item) ? 'justify-end' : 'justify-start'">
                    <v-tooltip bottom color="black" v-for="reaction in groupedReactions(item)" :key="reaction.emoji">
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          small
                          class="reaction-chip"
                          :color="reaction.isActive ? 'primary' : 'grey darken-3'"
                          :outlined="true"
                          @click.stop="openReactionDialog(item)"
                          v-bind="attrs"
                          v-on="on">
                          {{ reaction.emoji }}
                          <span class="ml-1 count">{{ reaction.count }}</span>
                        </v-chip>
                      </template>
                      <div v-html="reaction.users.join('<br>')"></div>
                    </v-tooltip>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </v-scroll-y-transition>
      </div>

      <div class="typing-indicator-container px-4 pb-1 d-flex align-center" style="min-height: 24px">
        <transition-group tag="div" class="d-flex align-center" name="avatar-fade">
          <v-avatar v-for="member in typingUsersList" :key="member.userId._id" size="32" class="typing-avatar">
            <v-img v-if="member.userId.bild" :src="'/img/profilbilder/' + member.userId.bild" :alt="member.userId.vorname"></v-img>
            <span v-else class="text-caption">{{ getInitials(member.userId) }}</span>
          </v-avatar>
        </transition-group>
        <span v-if="typingUsersList.length > 0" class="caption grey--text text--lighten-1 ml-2" style="font-style: italic">
          {{ typingUsersList.length > 1 ? "schreiben" : "schreibt" }} gerade
        </span>
      </div>
    </div>
    <v-sheet v-if="isEditing" dark color="grey darken-2" class="pa-2 d-flex" style="margin: 0 8px 80px 8px; border-radius: 12px">
      <v-icon small class="mr-2" color="primary">mdi-pencil</v-icon>
      <div class="flex-grow-1">
        <div class="font-weight-bold" style="line-height: 1.2">Nachricht bearbeiten</div>
        <div class="text-caption text-truncate" style="line-height: 1.2">
          {{ editingMessage.textContent }}
        </div>
      </div>
      <v-btn icon small @click="cancelEditMode">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </v-sheet>

   <transition name="slide-y-transition">
  <v-sheet
    v-if="replyingToMessage && !isEditing"
    dark
    class="reply-preview-sheet pa-2 d-flex align-center"
  >
    <div class="bar-indicator mr-2"></div>
    <div class="flex-grow-1" style="overflow: hidden; min-width: 0;">
      <div class="primary--text font-weight-bold caption mb-0" style="line-height: 1.1">
        Antwort an {{ replyingToMessage.senderId ? replyingToMessage.senderId.vorname : "..." }}
      </div>
      <div class="grey--text text--lighten-1 caption text-truncate">
        {{ replyingToMessage.textContent || (replyingToMessage.fileInfo ? '📷 Dateianhang' : '...') }}
      </div>
    </div>
    <v-btn icon small @click="setReplyTo(null)" class="ml-1">
      <v-icon small>mdi-close</v-icon>
    </v-btn>
  </v-sheet>
</transition>

    <v-menu
      v-model="isPopupMenuOpen"
      :close-on-content-click="false"
      :close-on-click="false"
      :open-on-click="false"
      :open-on-hover="false"
      offset-y
      top
      content-class="glass-menu popup-menu"
      max-height="300px">
      <template v-slot:activator="{ on }">
        <v-sheet dark class="message-input-area pa-2" v-on="on">
        <v-textarea
  ref="chatInput"
  v-model="newMessageText"
  @keydown.enter.exact="handleEnterKey"
  @keydown.enter.shift.exact="() => {}" 
  @keyup.esc="closeMenus"
  placeholder="Nachricht..."
  filled
  rounded
  dense
  auto-grow
  rows="1"
  max-rows="5"
  hide-details
  dark
  solo
  flat
  background-color="transparent"
  class="chat-input-textarea"
>
  <template v-slot:prepend>
    <v-btn icon @click="triggerFileUpload" class="mt-n1"> <v-icon>mdi-paperclip</v-icon>
    </v-btn>
  </template>

  <template v-slot:append-outer>
     <v-btn
        v-if="newMessageText.trim()"
        class="mt-n2"
        fab
        small
        depressed
        color="primary"
        @click="sendMessage"
        :key="isEditing ? 'edit' : 'send'">
        <v-icon>{{ isEditing ? "mdi-check" : "mdi-send" }}</v-icon>
      </v-btn>

      <v-btn
        v-else
        class="mt-n2"
        fab
        small
        depressed
        :color="isRecording ? 'red' : 'primary'"
        @mousedown.prevent="startRecording"
        @mouseup.prevent="stopRecording"
        @touchstart.prevent="startRecording"
        @touchend.prevent="stopRecording"
        @mouseleave="cancelRecording"
        key="record">
        <v-icon>{{ isRecording ? "mdi-stop" : "mdi-microphone" }}</v-icon>
      </v-btn>
  </template>
</v-textarea>
        </v-sheet>
      </template>
      <v-list dense v-if="popupMode === 'mentions'">
        <v-list-item v-for="member in mentionSuggestions" :key="member.userId._id" @click="selectMention(member)">
          <v-list-item-avatar size="32" class="mr-2">
            <v-img v-if="member.userId.bild" :src="'/img/profilbilder/' + member.userId.bild"></v-img>
            <span v-else>{{ getInitials(member.userId) }}</span>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ member.userId.vorname }} {{ member.userId.nachname }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <transition name="fade-transition">
      <div v-if="isSearchActive" class="search-overlay-backdrop" @click.self="toggleSearch(false)">
        
        <v-card class="search-glass-panel elevation-20" @click.stop>
          <div class="search-header">
            <v-icon color="primary" class="mr-3 search-icon-anim">mdi-magnify</v-icon>
            <input 
              ref="searchInput"
              v-model="searchInputModel"
              class="search-html-input"
              placeholder="Nachricht suchen..."
              @input="onSearchInput"
              @keydown.esc="toggleSearch(false)"
            />
            <v-btn icon small color="grey" @click="toggleSearch(false)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <v-divider style="border-color: rgba(255,255,255,0.08)"></v-divider>

          <div class="search-results-scroll custom-scrollbar">
            
            <div v-if="isSearching" class="pa-8 text-center">
               <v-progress-circular indeterminate size="32" color="primary" width="3"></v-progress-circular>
               <p class="caption grey--text mt-3">Durchsuche Chat...</p>
            </div>

            <div v-else-if="!searchInputModel" class="pa-8 text-center grey--text text--darken-1">
               <v-icon size="48" color="grey darken-3" class="mb-2">mdi-keyboard-outline</v-icon>
               <p class="body-2">Tippe, um zu suchen.</p>
            </div>

            <div v-else-if="searchResults.length === 0" class="pa-8 text-center grey--text text--darken-1">
               <v-icon size="48" color="grey darken-3" class="mb-2">mdi-emoticon-sad-outline</v-icon>
               <p class="body-2">Nichts gefunden für "{{ searchInputModel }}"</p>
            </div>

            <v-list v-else dark color="transparent" class="pa-2">
              <v-list-item 
                v-for="res in searchResults" 
                :key="res._id" 
                class="search-result-item mb-2"
                @click="handleJumpTo(res)"
                rounded="lg"
              >
                <v-list-item-avatar size="40" class="mr-3 align-self-start mt-2">
                   <v-img v-if="res.senderId.bild" :src="'/img/profilbilder/' + res.senderId.bild"></v-img>
                   <span v-else class="white--text font-weight-bold caption">{{ getInitials(res.senderId) }}</span>
                </v-list-item-avatar>

                <v-list-item-content>
                  <div class="d-flex justify-space-between align-center mb-1">
                     <span class="sender-label text-truncate primary--text">{{ res.senderId.vorname }} {{ res.senderId.nachname }}</span>
                     <span class="date-label grey--text caption">{{ formatDateShort(res.createdAt) }}</span>
                  </div>
                  <div class="result-snippet grey--text text--lighten-2" v-html="highlightText(res.textContent)"></div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-card>

      </div>
    </transition>
    <SendMediaPreviewDialog
      v-if="fileToPreview"
      v-model="showMediaPreviewDialog"
      :file="fileToPreview"
      @input="(val) => !val && (fileToPreview = null)" />
    <input
      type="file"
      ref="fileInput"
      @change="onFileSelected"
      style="display: none"
      accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.zip" />
  </div>
</template>
<script>
// (Wir brauchen 'saveAs' für die Download-Funktion)
import { saveAs } from "file-saver"
import { mapState, mapGetters, mapActions } from "vuex"
import ReadReceiptsDialog from "./readReceiptsDialog.vue"
import ForwardMessageDialog from "./forwardMessageDialog.vue"
import ReactionDetailsDialog from "./reactionDetailsDialog.vue"
import SendMediaPreviewDialog from "./chatSendMediaPreviewDialog.vue"
// Import der SecuredMedia-Komponente (Pfad ggf. anpassen)
import SecuredMedia from "./securedMedia.vue"
// Import des neuen Media-Viewers
import MediaViewerDialog from "./mediaViewerDialog.vue"
// Import der API (Pfad ggf. anpassen)
import api from "@/api"
// Axios für den File-Upload (wie in deiner Version)
import axios from "axios"
import userService from "@/services/userService" // WICHTIG!

export default {
  name: "ChatMessageView",
  components: {
    SecuredMedia,
    MediaViewerDialog, // NEU
    ChatGroupSettingsDialog: () => import("./chatGroupSettingsDialog.vue"),
    ReadReceiptsDialog,
    ForwardMessageDialog,
    SendMediaPreviewDialog,
    ReactionDetailsDialog,
  },
  data() {
    return {
      downloadingFileId: null,
      isReturningToPresent: false,
      userService,
      loadMoreObserver: null,
      isPaginating: false, // NEU: Verhindert Scroll-Logik-Konflikte
    beforePaginationScrollHeight: 0, // NEU: Speichert die Scroll-Höhe
      scrollContainerElement: null,
      recordedMimeType: '',
      isRecording: false,
    mediaRecorder: null,
    audioChunks: [],
    audioUploadTimer: null,
      showNewMessagesBanner: false,
      showReactionDialog: false,
      selectedMessageForReactions: null,
      quickReactions: ["👍", "❤️", "😂", "🔥", "🙏"],
      newMessageText: "",
      showForwardDialog: false,
      selectedMessageToForward: null,
      showSettingsDialog: false,
      isSearchActive: false,
      searchQuery: "",
      observer: null,
      readQueue: new Set(),
      readQueueTimer: null,
      isWindowFocused: true,
      showReadReceipts: false,
      selectedMessageForReceipts: null,
      typingTimer: null,
      amITyping: false,
      iAmSending: false,
      isInitialLoad: true,
      mentionMenu: false,
      mentionSuggestions: [],
      mentionQuery: "",
      mentionStartIndex: -1,
      popupMode: null,

      // --- NEU FÜR LANG-KLICK ---
      pressTimer: null, // Hält den setTimeout
      activePressId: null, // Welche Bubble wird gerade gedrückt (für Animation)
      activeMenuId: null, // Welche Menü ist offen
      activeMenuActivator: null, // Welches DOM-Element das Menü aktiviert hat
      activeMenuElement: null, // Hält das Element für den Animations-Reset

      // --- NEU FÜR MEDIA-VIEWER ---
      showMediaViewer: false,
      selectedMediaItem: null,

      pressStartX: 0,
      pressStartY: 0,

      showMediaPreviewDialog: false,
      fileToPreview: null,

      noMoreMessages: false,

      searchInputModel: "", // Für das neue Input-Feld
      searchDebounceTimer: null,
    }
  },
beforeRouteLeave(to, from, next) {
    // 1. Prüfen: Ist ein Chat offen ODER das Pinboard offen?
    if (this.activeGroupId || this.activeView === 'pinboard') {
      this.scrollContainerElement = null
      console.log(this.scrollContainerElement, 'etz löschin')
      // 2. Wenn ja: Schließe nur die Ansicht (zurück zur Liste)
      this.setActiveGroup(null) 
      
      // 3. Blockiere die eigentliche Routen-Navigation
      next(false)

    } else {
      // 4. Wenn wir schon auf der Liste sind: Lass den User raus (z.B. zum Dashboard)
      next()
    }
  },
  computed: {
    ...mapState("userStore", ["user"]),
    ...mapState("chatStore", ["searchResults", 
      "isSearching", 
      'isHistoryMode',
      "isJumping", 'activeGroupId', "isLoadingMessages", "replyingToMessage", "editingMessage", 'isLoadingMoreMessages']),
    ...mapGetters("chatStore", ["isPersonallyPinned", "isGloballyPinned", "activeGroupMessages", "activeGroupData", "getTypingUsersForActiveGroup", 'getHasMoreMessages']),
    hasPinRight() {
      return userService.hasRight("chat_globalpin")
    },
    hasMoreMessages() {
      if (this.noMoreMessages) return false;
      return true
  },
    groupedReactions() {
      return (message) => {
        if (!message.reactions || message.reactions.length === 0 || !this.activeGroupData || !this.activeGroupData.members) {
          return []
        }
        const allMembers = this.activeGroupData.members
        const groups = {}
        message.reactions.forEach((reaction) => {
          if (!reaction.userId) return
          const reactionUserId = (reaction.userId._id || reaction.userId).toString()
          const memberObject = allMembers.find((m) => m.userId && m.userId._id.toString() === reactionUserId)
          if (memberObject) {
            const user = memberObject.userId
            if (!groups[reaction.emoji]) {
              groups[reaction.emoji] = {
                emoji: reaction.emoji,
                count: 0,
                users: [],
                isActive: user._id === this.user._id,
              }
            }
            groups[reaction.emoji].count++
            groups[reaction.emoji].users.push(user.vorname)
            if (user._id === this.user._id) {
              groups[reaction.emoji].isActive = true
            }
          }
        })
        return Object.values(groups)
      }
    },
    isPopupMenuOpen: {
      get() {
        return this.popupMode !== null
      },
      set(value) {
        if (!value) {
          this.popupMode = null
        }
      },
    },
    isMyMention() {
      return (message) => {
        if (!message.mentions || !this.user) return false
        // (Stellt sicher, dass beide Typen (String vs Objekt) funktionieren)
        return message.mentions.some((m) => (m._id || m) === this.user._id)
      }
    },
    typingUsersList() {
      if (!this.user) return []
      return this.getTypingUsersForActiveGroup.filter((member) => member.userId._id !== this.user._id)
    },
    isEditing() {
      return this.editingMessage !== null
    },
    filteredMessages() {
      if (!this.searchQuery || !this.searchQuery.trim()) {
        return this.activeGroupMessages
      }
      const query = this.searchQuery.toLowerCase().trim()
      return this.activeGroupMessages.filter((message) => {
        if (message.isDeleted) return false
        return message.textContent && message.textContent.toLowerCase().includes(query)
      })
    },
    messagesWithDateSeparators() {
      const messages = this.filteredMessages
      if (!messages || messages.length === 0) return []
      const result = []
      let lastDate = null
      for (const message of messages) {
        const messageDate = new Date(message.createdAt).toLocaleDateString("de-CH")
        if (messageDate !== lastDate) {
          result.push({ isSeparator: true, date: this.formatDateSeparator(new Date(message.createdAt)) })
          lastDate = messageDate
        }
        result.push(message)
      }
      return result
    },
  },

  methods: {
    ...mapActions("chatStore", {
      returnToPresent: 'returnToPresent',
      performSearch: "performSearch", 
      jumpToMessage: "jumpToMessage", 
      clearSearch: "clearSearch",
      selectGroup: "setActiveGroup",
      dispatchSendMessage: "sendMessage",
      dispatchDeleteMessage: "deleteMessage",
      setReplyTo: "setReplyTo",
      setEditingMessage: "setEditingMessage",
      cancelEditing: "cancelEditing",
      dispatchEditMessage: "dispatchEditMessage",
      sendReadReceipts: "sendReadReceipts",
      viewUserProfile: "viewUserProfile",
      emitStartTyping: "emitStartTyping",
      emitStopTyping: "emitStopTyping",
      reactToMessage: "reactToMessage",
      fetchMoreMessages: "fetchMoreMessages",
      savePersonalPin: "savePersonalPin",
      removePersonalPin: "removePersonalPin",
      saveGlobalPin: "saveGlobalPin",
      removeGlobalPin: "removeGlobalPin"
    }),
    handleAppResume() {
      if (document.visibilityState === "visible" && this.activeGroupId) {
        
        console.log("App ist zurück im Vordergrund – Lade Nachrichten neu...");
        this.fetchMessagesForGroup(this.activeGroupId);
        
        this.sendReadReceipts({
          groupId: this.activeGroupId,
          messageIds: [] // (Oder Logik, um die neuen IDs zu holen, aber das macht dein Observer meist eh)
        });
      }
    },
 async handleReturnToPresent() {
      // 1. Button-Ladeanimation starten
      this.isReturningToPresent = true 
      
      try {
        // 2. WARTEN, bis die Nachrichten vom Server da sind
        await this.returnToPresent() 
        
        // 3. Optional: Suche schließen, falls sie noch offen war
        if (this.isSearchActive) {
          this.toggleSearch(false)
        }

        // 4. Scrollen erzwingen (wenn DOM fertig ist)
        this.$nextTick(() => {
          this.scrollToBottom()
          
          // Doppel-Sicherung: Falls Bilder noch das Layout verschieben, 
          // scrollen wir nach 150ms nochmal sicherheitshalber nach unten.
          setTimeout(() => {
            this.scrollToBottom()
          }, 150)
        })

      } catch (err) {
        console.error("Fehler beim Zurückkehren:", err)
      } finally {
        // 5. Button-Ladeanimation beenden
        this.isReturningToPresent = false
      }
    },
    toggleSearch(active) {
      this.isSearchActive = active
      if (active) {
        this.$nextTick(() => {
          // Fokus auf das native HTML Input setzen
          if (this.$refs.searchInput) this.$refs.searchInput.focus()
        })
      } else {
        this.searchInputModel = ""
        this.clearSearch()
      }
    },

    onSearchInput() {
      clearTimeout(this.searchDebounceTimer)
      this.searchDebounceTimer = setTimeout(() => {
        this.performSearch({
          groupId: this.activeGroupId,
          query: this.searchInputModel
        })
      }, 400) // 400ms warten bevor gesucht wird
    },

    async handleJumpTo(message) {
      // 1. Overlay schließen
      this.isSearchActive = false
      
      // 2. Springen (Store Action)
      const success = await this.jumpToMessage(message)
      
      if (success) {
        // 3. Kurz warten bis DOM da ist, dann scrollen & highlighten
        this.$nextTick(() => {
          this.scrollToMessage(message._id)
        })
      } else {
        // Fallback, falls Sprung fehlschlägt
        // this.$toast.error("Nachricht konnte nicht geladen werden")
      }
    },

    // Hilfsfunktion: Formatiert Datum kurz (z.B. "12. Nov")
    formatDateShort(isoStr) {
      const date = new Date(isoStr)
      return date.toLocaleDateString('de-CH', { day: 'numeric', month: 'short' })
    },

    // Hilfsfunktion: Markiert den Suchbegriff im Text
    highlightText(text) {
      if (!this.searchInputModel || !text) return text
      // Regex Case-Insensitive
      const regex = new RegExp(`(${this.searchInputModel})`, 'gi')
      // Wir wrappen den Treffer in einen grünen Span
      return text.replace(regex, '<span style="color: #00E676; font-weight: bold; background: rgba(0, 230, 118, 0.1); border-radius: 2px; padding: 0 2px;">$1</span>')
    },
    getFileIcon(fileInfo) {
      if (!fileInfo || !fileInfo.mimeType) return 'mdi-file-document-outline';
      const mime = fileInfo.mimeType;

      if (mime.includes('pdf')) return 'mdi-file-pdf-box';
      if (mime.includes('word') || mime.includes('application/msword') || mime.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document')) return 'mdi-file-word-box';
      if (mime.includes('excel') || mime.includes('application/vnd.ms-excel') || mime.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) return 'mdi-file-excel-box';
      if (mime.includes('zip') || mime.includes('application/zip')) return 'mdi-zip-box';
      if (mime.includes('audio')) return 'mdi-file-music-outline';
      
      // Standard-Fallback
      return 'mdi-file-document-outline';
    },
    loadMoreMessages() {
    // Verhindern, wenn wir schon laden oder es nichts mehr gibt
    if (this.isLoadingMoreMessages || !this.activeGroupId || !this.hasMoreMessages || this.isPaginating) return;
    
    this.isPaginating = true;
    
    // WICHTIG: Speichere die aktuelle Scroll-Höhe, BEVOR wir laden
    const container = this.$refs.messagesContainer;
    this.beforePaginationScrollHeight = container.scrollHeight;

    this.fetchMoreMessages(this.activeGroupId);
    this.noMoreMessages = !this.getHasMoreMessages(this.activeGroupId);

  },
  initLoadMoreObserver() {
  if (this.loadMoreObserver) {
    this.loadMoreObserver.disconnect();
  }
  const options = {
    root: this.$refs.messagesContainer, // Wichtig: Der Scroll-Container
    threshold: 0.1 // Bei 10% Sichtbarkeit auslösen
  }
  
  this.loadMoreObserver = new IntersectionObserver(this.handleLoadMoreIntersect, options);
  // $nextTick stellt sicher, dass der v-if="hasMoreMessages"
  // das ref="loadMoreTrigger" in den DOM gerendert hat.
  this.$nextTick(() => {
    if (this.$refs.loadMoreTrigger) {
      this.loadMoreObserver.observe(this.$refs.loadMoreTrigger);
    }
  });
},

/**
 * NEU: Callback für den Load-More-Observer
 */
handleLoadMoreIntersect(entries) {
  const entry = entries[0];
  if (entry.isIntersecting && !this.isLoadingMoreMessages) {
    // Sobald er sichtbar ist, lade mehr
    this.loadMoreMessages();
  }
},
    async startRecording() {
  if (this.newMessageText.trim() || this.isEditing) return;

  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    
    // --- NEUE FORMAT-PRÜFUNG ---
    const preferred = 'audio/mp4';
    const fallback = 'audio/webm';
    // Prüfe, ob der Browser 'audio/mp4' aufnehmen kann
    const options = { mimeType: MediaRecorder.isTypeSupported(preferred) ? preferred : fallback };
    
    // Speichere den Mime-Type, damit sendAudioFile ihn kennt
    this.recordedMimeType = options.mimeType; 
    // --- ENDE NEUE PRÜFUNG ---

    this.mediaRecorder = new MediaRecorder(stream, options);
    this.audioChunks = []; 

    this.mediaRecorder.ondataavailable = (event) => {
      this.audioChunks.push(event.data);
    };

    this.mediaRecorder.onstop = this.sendAudioFile;

    this.mediaRecorder.start();
    this.isRecording = true;

  } catch (err) {
    console.error("Fehler beim Zugriff auf das Mikrofon:", err);
  }
},
  /**
   * Stoppt die Audio-Aufnahme und löst 'onstop' (sendAudioFile) aus
   */
  stopRecording() {
    if (!this.mediaRecorder || !this.isRecording) return;
    
    this.mediaRecorder.stop(); // Löst this.mediaRecorder.onstop aus
    this.isRecording = false;

    // Stream-Tracks stoppen (gibt Mikrofon-Zugriff frei)
    this.mediaRecorder.stream.getTracks().forEach(track => track.stop());
  },

  /**
   * Bricht die Aufnahme ab (wenn Maus wegrutscht)
   */
  cancelRecording() {
    if (!this.mediaRecorder || !this.isRecording) return;

    this.mediaRecorder.onstop = null; // WICHTIG: Verhindert das Senden
    this.mediaRecorder.stop();
    this.isRecording = false;
    this.mediaRecorder.stream.getTracks().forEach(track => track.stop());
    this.audioChunks = [];
  },

async sendAudioFile() {
  if (this.audioChunks.length === 0) {
        return
      }

      const audioBlob = new Blob(this.audioChunks, { type: this.recordedMimeType })

      const fileExtension = this.recordedMimeType.includes("mp4") ? "mp4" : "webm"
      const audioFile = new File([audioBlob], `sprachnachricht.${fileExtension}`, {
        type: this.recordedMimeType,
      })

      this.audioChunks = [] // Sofort leeren
      this.fileToPreview = audioFile
      this.showMediaPreviewDialog = true
},
    onNewMessagesBannerClick() {
      this.showNewMessagesBanner = false
      this.scrollToBottom() // Scrollt nach ganz unten
    },

    // NEU: Wird beim Scrollen im Nachrichten-Container aufgerufen
    handleScroll() {
      // Diese Logik wird nur ausgeführt, wenn der Banner sichtbar ist
      if (!this.showNewMessagesBanner) return

      const container = this.$refs.messagesContainer
      if (!container) return

      // Prüft, ob der User manuell (fast) nach unten gescrollt ist
      const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 150

      if (isAtBottom) {
        // Banner ausblenden, da der User unten angekommen ist
        this.showNewMessagesBanner = false
      }
    },
    onPressStart(item, event) {
      clearTimeout(this.pressTimer)

      // 1. Start-Position speichern (funktioniert für Maus & Touch)
      this.pressStartY = event.clientY || event.touches[0].clientY
      this.pressStartX = event.clientX || event.touches[0].clientX

      this.activePressId = item._id

      // WICHTIG: Wir übergeben das DOM-Element an den Timer
      const element = event.currentTarget

      this.pressTimer = setTimeout(() => {
        // Das 'element' wird hier übergeben
        this.onLongPress(item, element)
      }, 400)
    },

    onPressEnd(item) {
      if (this.pressTimer) {
        // Timer lief noch (kein Long-Press & kein Scroll) -> ShortClick
        clearTimeout(this.pressTimer)
        this.pressTimer = null
        this.onShortClick(item)
      }
      this.activePressId = null
    },
    onMove(event) {
      if (!this.pressTimer) return

      // 2. Aktuelle Position holen
      const currentY = event.clientY || event.touches[0].clientY
      const currentX = event.clientX || event.touches[0].clientX

      // 3. Distanz berechnen
      const deltaY = Math.abs(currentY - this.pressStartY)
      const deltaX = Math.abs(currentX - this.pressStartX)
      // 4. Wenn der User mehr als 10px scrollt -> Timer abbrechen!
      if (deltaY > 10 || deltaX > 10) {
        clearTimeout(this.pressTimer)
        this.pressTimer = null
        this.activePressId = null // "Drücken"-Animation abbrechen
      }
    },
    onLongPress(item, element) {
      if (this.pressTimer) {
        clearTimeout(this.pressTimer)
        this.pressTimer = null
      }
      if (navigator.vibrate) {
        navigator.vibrate(100)
      }
      this.activePressId = null
      this.activeMenuElement = element
      this.activeMenuActivator = element // <--- Hier war der Fehler in meinem letzten Code
      this.activeMenuId = item._id
    },
    onShortClick(item) {
      // Nur Medien beim Kurzklick öffnen
      if (item.messageType === "image" || item.messageType === "video") {
        this.openMediaViewer(item)
      }
    },
    onMenuClose() {
      if (this.activeMenuElement) {
        // (Workaround, um 'bubble-lifted'-Klasse zu entfernen)
        this.activeMenuElement.classList.remove("bubble-lifted")
      }
      this.activeMenuId = null
      this.activeMenuActivator = null
      this.activeMenuElement = null
    },
    // --- ENDE KLICK-STEUERUNG ---

    // --- NEUE METHODE FÜR MEDIA-VIEWER ---
    openMediaViewer(item) {
      this.selectedMediaItem = item
      this.showMediaViewer = true
    },
    // --- ENDE MEDIA-VIEWER ---

    // --- DATEI-HANDLING METHODEN ---
    triggerFileUpload() {
      this.$refs.fileInput.click()
    },
    onFileSelected(event) {
      const file = event.target.files[0]
      if (!file) return

      // 1. Datei in 'data' speichern
      this.fileToPreview = file

      // 2. Dialog öffnen
      this.showMediaPreviewDialog = true

      // 3. Input zurücksetzen (damit man dieselbe Datei nochmal wählen kann)
      this.$refs.fileInput.value = null

      // 4. (Die ganze Axios- & FormData-Logik ist von hier entfernt)
    },
 async downloadSecuredFile(item) {
    if (this.downloadingFileId) return // Verhindert Doppelklicks
    
    this.downloadingFileId = item._id // Loading starten

    try {
      // 1. Datei-Stream vom Server holen
      const response = await api.fetchSecuredMedia(item.fileUrl)
      
      // 2. In ein Blob umwandeln
      const blob = new Blob([response.data], { type: response.headers["content-type"] })
      const originalName = item.fileInfo.originalName || "Datei"

      // 3. Flutter Check
      // Wir prüfen window.flutter_inappwebview direkt UND über den globalen Scope, sicher ist sicher.
      const flutterHandler = window.flutter_inappwebview || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.flutter_inappwebview);

      if (flutterHandler) {
        console.log("Sending to Flutter...")
        var reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onloadend = function () {
          var dataUrl = reader.result
          var base64 = dataUrl.split(",")[1]
          
          // Extension Logik...
          let extension = "file"
          if (originalName.includes('.')) {
             extension = originalName.split('.').pop()
          }
          
          // Den Handler aufrufen (Achte auf den korrekten Namen, den du in Flutter definiert hast)
          flutterHandler.callHandler(
            "blobToBase64Handler", 
            base64.toString(), 
            extension, 
            originalName
          )
        }
      } else {
        saveAs(blob, originalName)
      }
    } catch (err) {
      console.error("Download fehlgeschlagen", err)
      alert(err.message)
      this.$toast.error("Datei konnte nicht heruntergeladen werden.")
    } finally {
      // WICHTIG: Loading beenden
      this.downloadingFileId = null
    }
  },

    openReactionDialog(message) {
      this.selectedMessageForReactions = message
      this.showReactionDialog = true
    },
    onReactionClick(message, emoji) {
      this.reactToMessage({
        messageId: message._id,
        emoji: emoji,
      })
    },
    openForwardDialog(message) {
      this.selectedMessageToForward = message
      this.showForwardDialog = true
    },
    toggleSearch(active) {
      this.isSearchActive = active
      if (active) {
        this.$nextTick(() => {
          this.$refs.searchField.focus()
        })
      } else {
        this.searchQuery = ""
      }
    },
    clearSearch() {
      this.searchQuery = ""
      this.$refs.searchField.focus()
    },
    openReadReceipts(message) {
      this.selectedMessageForReceipts = message
      this.showReadReceipts = true
    },
    isMyMessage(message) {
      if (!this.user || !message.senderId) return false
      const senderId = message.senderId._id || message.senderId
      return senderId === this.user._id
    },
    formatTimestamp(timestamp) {
      return new Date(timestamp).toLocaleTimeString("de-CH", {
        hour: "2-digit",
        minute: "2-digit",
      })
    },
    formatDateSeparator(date) {
      const today = new Date()
      const yesterday = new Date(today)
      yesterday.setDate(yesterday.getDate() - 1)
      if (date.toLocaleDateString("de-CH") === today.toLocaleDateString("de-CH")) {
        return "Heute"
      }
      if (date.toLocaleDateString("de-CH") === yesterday.toLocaleDateString("de-CH")) {
        return "Gestern"
      }
      return date.toLocaleDateString("de-CH", { weekday: "long", year: "numeric", month: "long", day: "numeric" })
    },
    getInitials(user) {
      if (!user) return "?"
      const v = user.vorname || ""
      const n = user.nachname || ""
      return `${v.charAt(0).toUpperCase()}${n.charAt(0).toUpperCase()}`
    },
    scrollToMessage(messageId) {
      const element = document.getElementById("msg-" + messageId)
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" })
        element.classList.add("highlight-message")
        setTimeout(() => {
          element.classList.remove("highlight-message")
        }, 1500)
      }
    },
    sendMessage() {
      const trimmedText = this.newMessageText.trim()
      if (!trimmedText) return

      const mentionIds = []
      if (this.activeGroupData && this.activeGroupData.members) {
        this.activeGroupData.members.forEach((member) => {
          if (!member.userId) return // Sicherheit
          const fullName = `@${member.userId.vorname} ${member.userId.nachname}`
          if (trimmedText.includes(fullName)) {
            mentionIds.push(member.userId._id)
          }
        })
      }

      const payload = {
        textContent: trimmedText,
        messageType: "text",
        mentionIds: mentionIds,
      }
      if (this.isEditing) {
        this.dispatchEditMessage(payload)
      } else {
        this.dispatchSendMessage(payload)
      }
      this.newMessageText = ""
      this.closeMenus()
      clearTimeout(this.typingTimer)
      if (this.amITyping) {
        this.emitStopTyping()
        this.amITyping = false
      }
      this.iAmSending = true
    },
    deleteMessage(message) {
      if (confirm("Nachricht wirklich löschen?")) {
        this.dispatchDeleteMessage(message)
      }
    },
    selectMention(member) {
      const fullName = `@${member.userId.vorname} ${member.userId.nachname} `
      const text = this.newMessageText
      const before = text.substring(0, this.mentionStartIndex)
      const after = text.substring(this.mentionStartIndex + this.mentionQuery.length + 1)
      this.newMessageText = before + fullName + after
      this.closeMenus()
      this.$nextTick(() => {
        this.$refs.chatInput.focus()
      })
    },
    closeMenus() {
      this.popupMode = null
      this.mentionSuggestions = []
      this.mentionQuery = ""
      this.mentionStartIndex = -1
    },
    editMessage(message) {
      this.setEditingMessage(message)
      this.newMessageText = message.textContent
    },
    cancelEditMode() {
      this.cancelEditing()
      this.newMessageText = ""
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messagesContainer
        // Sicherheitscheck: Existiert der Container noch?
        if (container && container.scrollHeight) {
          container.scrollTop = container.scrollHeight
        }
      })
    },
    getReadStatus(message) {
      let status = { icon: "mdi-check", color: "white" }
      if (!this.activeGroupData || !this.activeGroupData.members) {
        return status
      }
      const readByList = message.readBy || []
      if (readByList.length > 0) {
        status = { icon: "mdi-check-all", color: "white" }
      }
      const totalOtherMembers = this.activeGroupData.members.filter((m) => m.userId && m.userId._id !== this.user._id).length
      const readByOthers = readByList.filter((r) => r.userId && r.userId._id !== this.user._id).length
      if (readByOthers >= totalOtherMembers) {
        status = { icon: "mdi-check-all", color: "var(--v-primary)" } // #00963f
      }
      return status
    },
    initReadObserver() {
      if (this.observer) this.observer.disconnect(); // Erst alten killen!
      const options = {
        root: this.$refs.messagesContainer,
        threshold: 0.8,
      }
      this.observer = new IntersectionObserver(this.handleObserverCallback, options)
      this.observeMessages()
    },
    handleTextInput(value) {
      if (!this.amITyping && value) {
        this.amITyping = true
        this.emitStartTyping()
      }
      clearTimeout(this.typingTimer)
      this.typingTimer = setTimeout(() => {
        if (this.amITyping) {
          this.emitStopTyping()
          this.amITyping = false
        }
      }, 2000)
    },
    observeMessages() {
      if (!this.observer || !this.$refs.messagesContainer) return
      const unreadBubbles = this.$refs.messagesContainer.querySelectorAll(".message-bubble.is-other:not(.observed)")
      unreadBubbles.forEach((bubble) => {
        const messageId = bubble.dataset.messageId
        const message = this.activeGroupMessages.find((m) => m._id === messageId)
        if (message && !this.isMessageReadByMe(message)) {
          bubble.classList.add("observed")
          this.observer.observe(bubble)
        }
      })
    },
    handleObserverCallback(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting && this.isWindowFocused) {
          const messageId = entry.target.dataset.messageId
          if (messageId) {
            this.readQueue.add(messageId)
            this.scheduleReadQueueSend()
            this.observer.unobserve(entry.target)
          }
        }
      })
    },
    scheduleReadQueueSend() {
      if (this.readQueueTimer) return
      this.readQueueTimer = setTimeout(() => {
        if (this.readQueue.size > 0 && this.activeGroupData) {
          const messageIds = Array.from(this.readQueue)
          this.sendReadReceipts({
            groupId: this.activeGroupData._id,
            messageIds: messageIds,
          })
          this.readQueue.clear()
        }
        this.readQueueTimer = null
      }, 2000)
    },
    isMessageReadByMe(message) {
      if (!message || !this.user) return true
      if (this.isMyMessage(message)) return true
      if (!message.readBy) return false
      return message.readBy.some((r) => (r.userId._id || r.userId) === this.user._id)
    },
    handleFocus() {
      this.isWindowFocused = true
    },
    handleBlur() {
      this.isWindowFocused = false
    },
    cleanupObserver() {
      if (this.observer) {
        this.observer.disconnect()
        this.observer = null
      }

      if (this.loadMoreObserver) {
    this.loadMoreObserver.disconnect();
    this.loadMoreObserver = null;
  }

      clearTimeout(this.readQueueTimer)
      this.readQueueTimer = null
      this.readQueue.clear()
      window.removeEventListener("focus", this.handleFocus)
      window.removeEventListener("blur", this.handleBlur)
    },
  },

  watch: {
    newMessageText(newValue) {
      if (this.isEditing) {
        /* (nichts tun) */
      } else {
        this.handleTextInput(newValue)
      }
      try {
        const input = this.$refs.chatInput.$refs.input
        const cursorPosition = input.selectionStart
        const textBeforeCursor = newValue.substring(0, cursorPosition)
        const atIndex = textBeforeCursor.lastIndexOf("@")
        const spaceAfterAt = textBeforeCursor.indexOf(" ", atIndex)
        if (atIndex > -1 && spaceAfterAt === -1) {
          this.mentionQuery = textBeforeCursor.substring(atIndex + 1).toLowerCase()
          this.mentionStartIndex = atIndex
          this.mentionSuggestions = this.activeGroupData.members.filter((member) => {
            if (member.userId._id === this.user._id) return false
            const name = `${member.userId.vorname} ${member.userId.nachname}`.toLowerCase()
            return name.includes(this.mentionQuery)
          })
          if (this.mentionSuggestions.length > 0) {
            this.popupMode = "mentions"
          } else {
            this.popupMode = null
          }
        } else {
          this.popupMode = null
        }
      } catch (e) {
        this.popupMode = null
      }
    },messagesWithDateSeparators: {
    handler(newMessages, oldMessages) {
      // (Die 'test'-Logs kannst du drin lassen oder entfernen)
      if (!newMessages || !this.$refs.messagesContainer) {
        return
      }
      const newLength = newMessages.length
      const oldLength = oldMessages ? oldMessages.length : 0
      const wasMessageAdded = newLength > oldLength

      this.$nextTick(() => {
        const container = this.$refs.messagesContainer
        if (!container) return;

        if (this.isPaginating) {
          
          const newScrollHeight = container.scrollHeight;
          const oldScrollHeight = this.beforePaginationScrollHeight;
          
          // Setze den Scroll-Top auf die Differenz
          container.scrollTop = newScrollHeight - oldScrollHeight;
          
          // Flag zurücksetzen
          this.isPaginating = false;
          return; // WICHTIG: Nicht nach unten scrollen!
        }

        // 2. FALL: INITIALES LADEN
        if (this.isInitialLoad && newLength > 0) {
          this.scrollToBottom()
          this.isInitialLoad = false
        } 
        // 3. FALL: EINE NEUE NACHRICHT KAM AN
        else if (wasMessageAdded) {
          
          // (Deine bestehende Logik für "iAmSending" und "showNewMessagesBanner"
          //  ist hier perfekt und bleibt unverändert)
          if (this.iAmSending) {
            this.scrollToBottom()
            this.iAmSending = false
            
          } else {
            if (!container) return

            const tolerance = 300
            const isScrolledUp = container.scrollTop + container.clientHeight < container.scrollHeight - tolerance
            if (isScrolledUp) {
              this.showNewMessagesBanner = true
            } else {
              this.scrollToBottom()
            }
          }
        }
        this.observeMessages()
      })
    },
    deep: true,
  },
   activeGroupData(newData, oldData) {
   if (newData && oldData && newData._id !== oldData._id) { 
      this.cleanupObserver(); 
      this.isInitialLoad = true;
      this.$nextTick(() => {
        this.initReadObserver();
        this.scrollContainerElement = this.$refs.messagesContainer; 
        this.initLoadMoreObserver(); 

      });
    }
  },
    editingMessage(newMessage) {
      if (newMessage) {
        this.newMessageText = newMessage.textContent
      } else {
        if (!this.replyingToMessage) {
          this.newMessageText = ""
        }
      }
    },
  },
 mounted() {
    this.scrollContainerElement = this.$refs.messagesContainer; 
    
    if (this.activeGroupData) {
      this.initReadObserver();
      this.initLoadMoreObserver(); 
      this.scrollToBottom();
      setTimeout(() => this.scrollToBottom(), 200); 
    }
    window.addEventListener("focus", this.handleFocus)
    window.addEventListener("blur", this.handleBlur)

    // --- NEU: Listener für Tab-Wechsel / App-Background ---
    document.addEventListener("visibilitychange", this.handleAppResume);
    
    // Falls du Cordova/Capacitor nutzt, ist "resume" oft noch zuverlässiger:
    document.addEventListener("resume", this.handleAppResume);
  },

  beforeDestroy() {
    this.cleanupObserver()
    clearTimeout(this.typingTimer)
    
    // --- NEU: Aufräumen nicht vergessen! ---
    document.removeEventListener("visibilitychange", this.handleAppResume);
    document.removeEventListener("resume", this.handleAppResume);
  },
}
</script>
<style lang="scss" scoped>
  .message-content {
  white-space: pre-wrap;      /* WICHTIG: Behält Zeilenumbrüche bei */
  word-break: break-word;     /* WICHTIG: Bricht extrem lange Wörter um, damit das Layout nicht kaputt geht */
  line-height: 1.5;           /* Sieht bei mehrzeiligem Text besser aus */
}
/* =========================================
   1. CONTAINER & HINTERGRUND
   ========================================= */
.d-flex.flex-column.fill-height {
  background-color: #0f0f0f;
  background-image: 
    radial-gradient(circle at 0% 0%, rgba(0, 150, 63, 0.08), transparent 40%),
    radial-gradient(circle at 100% 100%, rgba(0, 0, 0, 0.8), transparent 40%);
  position: relative; /* Wichtig für absolute Positionierung */
}

.chat-messages-container {
  overflow-y: auto;
  height: 100%; /* Nimmt jetzt die volle Höhe inkl. hinter dem Input */
  flex-grow: 1;
  
  /* WICHTIG: Viel Platz unten lassen, damit man die letzte Nachricht 
     unter dem schwebenden Input hervorholen kann */
  padding-bottom: 100px !important; 

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255,255,255,0.1);
    border-radius: 3px;
  }
}

/* =========================================
   2. MESSAGE BUBBLES
   ========================================= */
.message-bubble {
  display: inline-block;
  min-width: 120px;
  max-width: 85%;
  overflow-wrap: break-word;
  padding: 10px 14px 22px 14px;
  position: relative;
  font-size: 0.95rem;
  line-height: 1.4;
  border-radius: 18px; /* Noch etwas runder */
  transition: transform 0.1s, box-shadow 0.2s;
  overflow: hidden; 
  
  /* WICHTIG: Fix für den Z-Index Bug */
  /* Wir entfernen z-index hier, damit das Menü gewinnen kann */
  z-index: 1; 
}

.message-bubble.is-me {
  background: linear-gradient(145deg, #0f6030 0%, #004d25 100%);
  color: #eefbf2;
  border-bottom-right-radius: 4px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.message-bubble.is-other {
  background-color: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.03);
  color: #e0e0e0;
  border-bottom-left-radius: 4px !important;
  backdrop-filter: blur(5px); /* Leichtes Blur für Bubbles untereinander */
}

.sender-name {
  font-size: 0.75rem;
  margin-bottom: 4px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 600;
}

/* Animation beim Drücken */
.message-bubble.bubble-pressing {
  transform: scale(0.97);
  opacity: 0.9;
}
/* Wenn das Menü offen ist: Wir heben es NICHT mehr per z-index an, 
   sondern lassen Vuetify das Menü drüberlegen */
.message-bubble.bubble-lifted {
  /* Nur optisches Feedback, kein z-index War! */
  box-shadow: 0 0 0 2px rgba(255,255,255,0.1); 
}

/* Der Container (Das "Glas") */
.glass-menu {
  background-color: rgba(20, 20, 20, 0.8) !important; /* Dunkler & deckender */
  backdrop-filter: blur(50px) saturate(180%) !important; /* Extrem weicher Blur */
  
  /* Doppelter Border-Trick für 3D-Effekt */
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  box-shadow: 
    inset 0 1px 0 0 rgba(255, 255, 255, 0.1), /* Inneres Highlight oben */
    0 20px 60px rgba(0, 0, 0, 0.8) !important; /* Tiefer Schatten */
    
  border-radius: 20px !important;
  overflow: hidden;
  min-width: 220px; /* Etwas breiter für Eleganz */
}

/* Die Liste darin */
.glass-menu .v-list {
  background: transparent !important;
  padding: 8px;
}

/* --- Die Menü-Einträge (Items) --- */
 .glass-menu .v-list-item {
  border-radius: 12px;
  margin-bottom: 4px;
  transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
  padding: 0 12px; /* Etwas kompakter seitlich */
  min-height: 44px;
}

.glass-menu .v-list-item:hover {
  background: rgba(255, 255, 255, 0.08);
  transform: translateX(4px); /* Kleine Bewegung */
}

/* Klick-Effekt */
.glass-menu .v-list-item:active {
  transform: scale(0.98) translateX(4px);
  background: rgba(255, 255, 255, 0.12);
}

/* --- Icons & Text Styling --- */
.glass-menu .v-list-item__icon {
  margin-right: 12px !important;
}

.glass-menu .v-icon {
  font-size: 20px; /* Dezentere Icons */
  opacity: 0.7;
  transition: 0.2s;
}

 .glass-menu .v-list-item:hover .v-icon {
  opacity: 1;
  transform: scale(1.15);
  filter: drop-shadow(0 0 5px rgba(255,255,255,0.4));
}
.glass-menu .v-list-item__title {
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.3px;
  color: rgba(255, 255, 255, 0.9);
}
.glass-menu .v-divider {
  border-color: rgba(255, 255, 255, 0.08) !important;
  margin: 4px 0;
}
.glass-menu .v-list-item:hover .mdi-delete {
  filter: drop-shadow(0 0 8px rgba(255, 50, 50, 0.6));
}

/* =========================================
   4. INPUT AREA (Textarea Style)
   ========================================= */
.message-input-area {
  /* Macht den Input zum "Overlay" */
  position: absolute; 
  bottom: 0;
  left: 0;
  right: 0;
  
  margin: 0 12px 12px 12px;
  width: auto;
  
  border-radius: 24px !important;
  
  /* Hier machen wir es transparenter (0.65 statt 0.75), 
     damit die Nachrichten dahinter durchscheinen */
  background-color: rgba(20, 20, 20, 0.7) !important;
  backdrop-filter: blur(20px) saturate(150%);
  
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  border-left: 1px solid rgba(255, 255, 255, 0.05);
  border-right: 1px solid rgba(255, 255, 255, 0.05);
  
  box-shadow: 0 10px 30px rgba(0,0,0,0.5);
  z-index: 5;
  
  transition: height 0.2s ease;
}

.chat-input-textarea {
  padding-top: 0 !important;
  margin-top: 0 !important;
}

/* WICHTIG: Hier MUSS ::v-deep (oder >>>) bleiben!
   Sonst malt Vuetify den Hintergrund grau an und verdeckt unseren Glass-Effekt. */
::v-deep .v-input__slot {
  background: transparent !important; 
  box-shadow: none !important;
}

/* Scrollbar im Input Feld */
::v-deep textarea::-webkit-scrollbar {
  width: 4px;
}
::v-deep textarea::-webkit-scrollbar-thumb {
  background-color: rgba(255,255,255,0.2);
  border-radius: 4px;
}

/* =========================================
   5. DETAILS
   ========================================= */
.message-time {
  position: absolute;
  bottom: 5px;
  right: 10px;
  font-size: 0.65rem;
  opacity: 0.7;
  font-weight: 500;
  pointer-events: none;
  display: flex;
  align-items: center;
  text-shadow: 0 1px 2px rgba(0,0,0,0.5);
}

.reply-bubble {
  background-color: rgba(0, 0, 0, 0.25); 
  border-left: 3px solid rgba(255, 255, 255, 0.6);
  border-radius: 6px;
  padding: 6px 8px;
  margin-bottom: 6px;
  max-width: 100%; 
  min-width: 0;
}
.reply-bubble-sender {
  font-size: 0.75rem;
  font-weight: bold;
  color: #a5d6a7 !important;
  margin-bottom: 2px;
}
.reply-bubble-content {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.85);
  
  /* FIX für Mobile: Erlaubt Umbruch, schneidet aber nach 1 Zeile ab */
  display: -webkit-box;
  -webkit-line-clamp: 1; 
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal; /* WICHTIG: Erlaubt dem Container, nicht breiter zu werden als verfügbar */
  word-break: break-word; /* Verhindert Layout-Sprengung durch lange Wörter/Links */
}

/* Reaction Chips */
.reaction-chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
}
.reaction-chip {
  font-size: 0.75rem;
  height: 22px;
  background: rgba(0,0,0,0.4) !important;
  border: 1px solid rgba(255,255,255,0.1);
  backdrop-filter: blur(4px);
}

/* Date Separator */
.date-separator {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 24px 0;
}
.date-separator span {
  background: rgba(30, 30, 30, 0.6);
  backdrop-filter: blur(10px);
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
  border: 1px solid rgba(255,255,255,0.05);
}
.date-separator::before, .date-separator::after { display: none; }

/* System Message */
.system-message {
  background: rgba(255, 255, 255, 0.04) !important; 
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.05);
  color: #888 !important;
  text-align: center;
  font-size: 0.8rem;
  font-style: italic;
  margin: 12px auto;
  max-width: 90%;
  border-radius: 12px !important;
  box-shadow: none !important;
}

/* Media Fixes */
::v-deep .secured-media-content {
  max-width: 100% !important;
  max-height: 400px !important;
  border-radius: 8px;
  display: block;
  margin-top: 4px;
}
::v-deep video.secured-media-content {
  max-width: 100% !important;
  max-height: 400px !important;
}

::v-deep .emoji-mart {
  background-color: #1e1e1e !important;
  border: 1px solid #333;
}
/* =========================================
   SEARCH OVERLAY (The Command Center)
   ========================================= */

/* Der Hintergrund (dunkelt den Chat ab) */
.search-overlay-backdrop {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(3px); /* Chat im Hintergrund weichzeichnen */
  z-index: 50; /* Über allem */
  display: flex;
  justify-content: center;
  align-items: flex-start; /* Oben ausgerichtet */
  padding-top: 80px; /* Abstand von oben */
}

/* Das Panel selbst */
.search-glass-panel {
  width: 90%;
  max-width: 500px;
  max-height: 60vh; /* Max 60% Bildschirmhöhe */
  display: flex;
  flex-direction: column;
  
  background-color: rgba(25, 25, 25, 0.85) !important;
  backdrop-filter: blur(30px) saturate(180%) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.8) !important;
  border-radius: 24px !important;
  overflow: hidden;
  
  /* Animation beim Erscheinen */
  animation: slideDown 0.3s cubic-bezier(0.2, 0.8, 0.2, 1);
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-20px) scale(0.95); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

/* Header Bereich */
.search-header {
  padding: 16px 20px;
  display: flex;
  align-items: center;
  background: rgba(255,255,255,0.02);
}

/* Das Eingabefeld (Native HTML für volle Kontrolle) */
.search-html-input {
  flex-grow: 1;
  background: transparent;
  border: none;
  color: white;
  font-size: 1.1rem;
  font-weight: 500;
  outline: none;
  margin: 0 12px;
  
  &::placeholder {
    color: rgba(255,255,255,0.3);
  }
}

.search-icon-anim {
  /* Kleiner Puls-Effekt */
  animation: pulse 2s infinite;
}
@keyframes pulse {
  0% { opacity: 0.7; }
  50% { opacity: 1; text-shadow: 0 0 10px var(--v-primary); }
  100% { opacity: 0.7; }
}

/* Result List Area */
.search-results-scroll {
  overflow-y: auto;
  flex-grow: 1; /* Füllt den restlichen Platz */
}

/* Ein einzelnes Ergebnis */
.search-result-item {
  border-radius: 12px !important;
  transition: all 0.2s;
  cursor: pointer;
  border: 1px solid transparent;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.05);
    transform: translateX(4px);
  }
}

.sender-label {
  font-weight: 700;
  font-size: 0.9rem;
}

.result-snippet {
  font-size: 0.9rem;
  line-height: 1.4;
  
  /* Begrenzung auf 2 Zeilen */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Custom Scrollbar */
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(255,255,255,0.15);
  border-radius: 3px;
}
.floating-fabs-container {
  position: absolute;
  bottom: 90px; /* Über dem Input-Feld (das ist ca 60-70px hoch) */
  right: 20px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  pointer-events: none; /* Container lässt Klicks durch */
}

.floating-fabs-container > .v-btn {
  pointer-events: auto; /* Buttons sind klickbar */
}

.history-fab {
  border: 1px solid rgba(255,255,255,0.1);
  /* Glass Effect für den Button */
  background-color: rgba(30, 30, 30, 0.85) !important;
  backdrop-filter: blur(10px);
}

.new-msgs-btn {
  /* Dein existierender Style für den Banner */
  pointer-events: auto;
  box-shadow: 0 4px 15px -2px rgba(0, 150, 63, 0.5) !important;
}

/* FIX: Reply Sheet Styles */
.reply-preview-sheet {
  position: absolute;
  bottom: 75px; /* Knapp über dem Input-Feld */
  left: 12px;
  right: 12px;
  background-color: rgba(30, 30, 30, 0.95) !important;
  backdrop-filter: blur(10px);
  border-radius: 12px 12px 12px 0; /* Kleines Design-Detail */
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 -5px 20px rgba(0,0,0,0.3);
  z-index: 4; /* Unter dem Input (z-index 5), aber über den Nachrichten */
  max-height: 60px; /* WICHTIG: Begrenzte Höhe */
}

.bar-indicator {
  width: 3px;
  height: 32px;
  background-color: var(--v-primary-base);
  border-radius: 2px;
}
</style>